// Customizer const
export const TOGGLE_COLLAPSED_NAV = "TOGGLE_COLLAPSE_MENU";
export const WINDOW_WIDTH = "WINDOW-WIDTH";
export const SWITCH_LANGUAGE = "SWITCH-LANGUAGE";

//Contact Module const
export const FETCH_START = "fetch_start";
export const FETCH_SUCCESS = "fetch_success";
export const FETCH_ERROR = "fetch_error";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const HIDE_MESSAGE = "HIDE_MESSAGE";
export const ON_SHOW_LOADER = "ON_SHOW_LOADER";
export const ON_HIDE_LOADER = "ON_HIDE_LOADER";

//Auth const
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNIN_GOOGLE_USER = "SIGNIN_GOOGLE_USER";
export const SIGNIN_GOOGLE_USER_SUCCESS = "SIGNIN_GOOGLE_USER_SUCCESS";
export const SIGNIN_FACEBOOK_USER = "SIGNIN_FACEBOOK_USER";
export const SIGNIN_FACEBOOK_USER_SUCCESS = "SIGNIN_FACEBOOK_USER_SUCCESS";
export const SIGNIN_TWITTER_USER = "SIGNIN_TWITTER_USER";
export const SIGNIN_TWITTER_USER_SUCCESS = "SIGNIN_TWITTER_USER_SUCCESS";
export const SIGNIN_GITHUB_USER = "SIGNIN_GITHUB_USER";
export const SIGNIN_GITHUB_USER_SUCCESS = "signin_github_user_success";
export const SIGNIN_USER = "SIGNIN_USER";
export const LOGIN_USER_INFO = "LOGIN_USER_INFO";
export const FETCH_USER_INFO = "FETCH_USER_INFO";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER = "SIGNOUT_USER";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const INIT_URL = "INIT_URL";

//Sticky
export const GET_STICKY = "GET_STICKY";
export const NOTES_UPDATE = "NOTES_UPDATE";
export const FETCH_ALL_NOTES_SUCCESS = "FETCH_ALL_NOTES_SUCCESS";
export const UPDATE_ALL_NOTES_SUCCESS = "UPDATE_ALL_NOTES_SUCCESS";

//Contact
export const GET_All_CONTACT_SUCCESS = "GET_All_CONTACT_SUCCESS";
export const ON_ADD_CONTACT_SUCCESS = "ON_ADD_CONTACT_SUCCESS";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const DELETE_CONTACT_SUCCESS = "DELETE_CONTACT_SUCCESS";

//finance
export const ACTION_COUNT = "ACTION_COUNT";

//Chat
export const SET_CHAT_USERS = "SET_CHAT_USERS";
export const SET_SELECTED_CHAT_USER = "SET_SELECTED_CHAT_USER";
export const SET_SESSION_ADDRESS = "SET_SESSION_ADDRESS";
export const SET_ROOSTER_LIST = "SET_ROOSTER_LIST";
export const SET_COVERSATION_DATA = "SET_COVERSATION_DATA";
export const RESET_CHAT_DATA = "RESET_CHAT_DATA";

//Spares
export const SET_WAREHOUSE_LIST = "SET_WAREHOUSE_LIST";
export const SET_WH_LOADING = "SET_WH_LOADING";
export const SET_WH_MODAL_LOADING = "SET_WH_MODAL_LOADING";
export const SET_SPARE_TRACK_LOADING = "SET_SPARE_TRACK_LOADING";
export const SET_SPARE_TRACKING_DATA = "SET_SPARE_TRACKING_DATA";
export const SET_SPARE_RETURN_LOADING = "SET_SPARE_RETURN_LOADING";
export const SET_DOA_SPARES = "SET_DOA_SPARES";
export const SET_DOA_SPARES_LOADING = "SET_DOA_SPARES_LOADING";

// Product tracking
export const SET_PRODUCT_TRACK_LOADING = "SET_PRODUCT_TRACK_LOADING";
export const SET_PRODUCT_MOVEMENT_DATA = "SET_PRODUCT_MOVEMENT_DATA";
export const SET_PRODUCT_TRACKING_META = "SET_PRODUCT_TRACKING_META";

// Logistics product tracking workspace (logistics_user role)
export const LOGISTICS_PT_RESET = "LOGISTICS_PT_RESET";
export const LOGISTICS_PT_WORKSPACE_LOAD_START = "LOGISTICS_PT_WORKSPACE_LOAD_START";
export const LOGISTICS_PT_WORKSPACE_LOAD_SUCCESS = "LOGISTICS_PT_WORKSPACE_LOAD_SUCCESS";
export const LOGISTICS_PT_WORKSPACE_LOAD_ERROR = "LOGISTICS_PT_WORKSPACE_LOAD_ERROR";

//Tasks
export const FETCH_TASKS_START = "FETCH_TASKS_START";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const FETCH_TASKS_ERROR = "FETCH_TASKS_ERROR";
export const FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS";
export const SET_TASKS_FILTER = "SET_TASKS_FILTER";
export const SET_TASKS_SEARCH_QUERY = "SET_TASKS_SEARCH_QUERY";
export const SET_TASKS_PROJECT_FILTER = "SET_TASKS_PROJECT_FILTER";
export const SET_TASKS_STATUS_FILTER = "SET_TASKS_STATUS_FILTER";
export const SET_VIEW_MODE = "SET_VIEW_MODE";
export const SET_SELECTED_TASKS = "SET_SELECTED_TASKS";
export const TOGGLE_TASK_SELECTION = "TOGGLE_TASK_SELECTION";
export const SELECT_ALL_TASKS = "SELECT_ALL_TASKS";
export const CLEAR_TASK_SELECTION = "CLEAR_TASK_SELECTION";
export const SET_SELECTED_TASK = "SET_SELECTED_TASK";
export const TOGGLE_FILTERS = "TOGGLE_FILTERS";
export const SET_PAGE = "SET_PAGE";
export const SET_PAGE_SIZE = "SET_PAGE_SIZE";
export const LOAD_MORE_TASKS = "LOAD_MORE_TASKS";
export const OPEN_DRAWER = "OPEN_DRAWER";
export const CLOSE_DRAWER = "CLOSE_DRAWER";
export const SET_DRAWER_SEARCH_QUERY = "SET_DRAWER_SEARCH_QUERY";
export const SET_TASKS_TASK_TYPE_FILTER = "SET_TASKS_TASK_TYPE_FILTER";
export const SET_TASKS_NUMBER_FILTER = "SET_TASKS_NUMBER_FILTER";
export const SET_TASKS_CTI_FILTER = "SET_TASKS_CTI_FILTER";
export const SET_TASKS_ORDER_FILTER = "SET_TASKS_ORDER_FILTER";
export const SET_TASKS_PROJECT_ID_FILTER = "SET_TASKS_PROJECT_ID_FILTER";
export const SET_TASKS_SOW_FILTER = "SET_TASKS_SOW_FILTER";
export const SET_TASKS_DISTRICT_FILTER = "SET_TASKS_DISTRICT_FILTER";
export const SET_TASKS_IS_HOLD_FILTER = "SET_TASKS_IS_HOLD_FILTER";
export const SET_TASKS_PINCODES_FILTER = "SET_TASKS_PINCODES_FILTER";
export const SET_TASKS_HRVID_OR_EMAIL_FILTER = "SET_TASKS_HRVID_OR_EMAIL_FILTER";
export const SET_TASKS_ALLOC_PARTNER_TYPE_FILTER = "SET_TASKS_ALLOC_PARTNER_TYPE_FILTER";
export const RESET_TASKS_FILTERS = "RESET_TASKS_FILTERS";

// Ticket details v2 (parallel layout; no sagas)
export const TICKET_DETAILS_V2_FETCH_START = "TICKET_DETAILS_V2_FETCH_START";
export const TICKET_DETAILS_V2_FETCH_SUCCESS = "TICKET_DETAILS_V2_FETCH_SUCCESS";
export const TICKET_DETAILS_V2_FETCH_ERROR = "TICKET_DETAILS_V2_FETCH_ERROR";
export const TICKET_DETAILS_V2_RESET = "TICKET_DETAILS_V2_RESET";
